import { EconomicOperator, EconomicOperatorAttribute } from "@medapro-types/common/compliance/economic-operators";
import api from "./api";
import endpoints from "./endpoints";

export default {
  getEconomicOperators: async function (): Promise<EconomicOperator[]> {
    const response = await api.get(endpoints.economicOperator.getAll);
    return response.data;
  },
  save: async function (economicOperator: EconomicOperator) {
    const data = {
      economicOperatorId: economicOperator.economicOperatorId,
      attributeValues: economicOperator.attributeValues
    };

    const response = await api.post(endpoints.economicOperator.save, data);
    return response.data;
  },
  getEconomicOperatorAttributes: async function (): Promise<EconomicOperatorAttribute[]> {
    const response = await api.get(endpoints.economicOperator.attributes.getAll);
    return response.data;
  },
  delete: async function (economicOperatorId: string): Promise<string> {
    const response = await api.post(
      endpoints.economicOperator.delete,
      {},
      {
        params: {
          economicOperatorId: economicOperatorId
        }
      }
    );

    return response.data;
  },
  exportAll: async function (abortSignal?: AbortSignal | null): Promise<string> {
    const response = await api.post(
      endpoints.economicOperator.exportAll,
      {},
      {
        signal: abortSignal
      }
    );

    return response.data;
  },
  import: async function (file: File, abortSignal?: AbortSignal | null): Promise<string> {
    const response = await api.post(
      endpoints.economicOperator.import,
      {
        file
      },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        signal: abortSignal
      }
    );

    return response.data;
  }
};
